import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-ticker',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ticker-kapsayici">
      <span class="ticker-metin" [style.animation-duration]="animSure()">{{ metin() }}</span>
    </div>
  `,
  styles: [`
    :host { display: block; overflow: hidden; }
    .ticker-kapsayici {
      width: 100%; overflow: hidden; white-space: nowrap;
      padding: 6px 0;
    }
    .ticker-metin {
      display: inline-block; white-space: nowrap;
      font-size: 14px; font-weight: 500;
      color: var(--py-metin, #262626);
      animation: ticker linear infinite;
    }
    @keyframes ticker {
      0%   { transform: translateX(100%); }
      100% { transform: translateX(-100%); }
    }
  `],
})
export class TickerComponent {
  metin = input('');
  hiz = input(10);

  animSure = computed(() => this.hiz() + 's');
}
